import { useNewCommunication } from "..";
import {
  Button,
  TextField,
  MenuItem,
  Box,
  DialogActions,
  DialogContent,
  Stack,
  FormControlLabel,
  Switch,
  DialogTitle,
  Container,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";

const validationSchema = yup.object({
  subject: yup.string("Oggetto").required("Il campo non puo essere vuoto!"),
  content: yup.string("Contenuto").required("Il campo non puo essere vuoto!"),
});

function AddCommunication() {
  const newCommunication = useNewCommunication();

  // === Form handling ===
  const formik = useFormik({
    initialValues: {
      subject: "",
      content: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      newCommunication.mutate({ ...values });

      // reset fields
      formik.handleReset();
    },
  });

  return (
    <Container sx={{ width: "50%" }}>
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle>Nuova comunicazione</DialogTitle>
        <DialogContent>
          <Box>
            <TextField
              autoFocus
              margin="dense"
              fullWidth
              id="subject"
              name="subject"
              label="Oggetto"
              type="text"
              variant="standard"
              onChange={formik.handleChange}
              value={formik.values.subject}
              error={formik.touched.subject && Boolean(formik.errors.subject)}
              helperText={formik.touched.subject && formik.errors.subject}
            />

            <TextField
              autoFocus
              margin="dense"
              fullWidth
              multiline
              id="content"
              name="content"
              label="Contenuto"
              type="text"
              variant="standard"
              onChange={formik.handleChange}
              value={formik.values.content}
              error={formik.touched.content && Boolean(formik.errors.content)}
              helperText={formik.touched.content && formik.errors.content}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button disabled={newCommunication.isLoading} type="submit">
            Invia
          </Button>
          <Button
            disabled={newCommunication.isLoading}
            onClick={formik.handleReset}
            color="error"
          >
            Reset
          </Button>
        </DialogActions>
      </form>
    </Container>
  );
}
export default AddCommunication;
